<template>
  <div>
    <VForm
      :fields="fields"
      :name="name"
      :submitButton="{ classType: 'primary giant', label: 'Reset Password' }"
      :disabled="isLoading || !isValid"
      @submit="onSubmit"
    >
    </VForm>

    <div class="buttons-wrapper">
      <div class="bottom-buttons-wrapper">
        <v-link type="gray" label="Go to login" routerLink="/login"></v-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VLink from "@/components/VLink";
import withNavigate from "@/mixins/withNavigate";
import VForm from "@/components/VForm";
import { required, email } from "@/utils/validations";
import { mapActions } from "vuex";
import withForm from "@/mixins/withForm";

export default Vue.component("ForgotPasswordForm", {
  components: {
    VLink,
    VForm
  },

  data() {
    return {
      name: "forgotPassword",
      fields: [
        {
          name: "email",
          label: "Email",
          classType: "primary",
          extraClass: "auth-input-fp",
          validate: [required, email]
        }
      ]
    };
  },

  mixins: [withForm, withNavigate],

  methods: {
    onSubmit() {
      this.validateForm();

      if (this.isValid) {
        this.resetPasswordInit({
          data: this.formValues,
          cb: () => {
            this.navigate("/forgot-password/success");
          }
        });
      }
    },

    ...mapActions("auth", ["resetPasswordInit"])
  },

  computed: {
    isLoading() {
      return this.$store.state.auth.isLoading;
    }
  }
});
</script>

<style lang="scss">
.buttons-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  text-align: center;
  line-height: 1.2;
}

.top-button-wrapper {
  margin: 50px 0 30px 0;
}

.bottom-buttons-wrapper {
  display: flex;
}


.auth-input-fp {
  width: 100%;
  margin-bottom: 15px;

  .error {
    /*margin-top: 10px;*/
  }
}

/deep/ .submit-btn-wrapper {
  button {
    width: 200px;
  }
}
</style>
